import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { InlineSVGModule } from 'ng-inline-svg';
import { SafePipe } from './safe.pipe';


import { AppComponent } from './app.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { DataService } from './app-service/data.service';
import { AppBodyComponent } from './app-body/app-body.component';

import { IconsComponent } from './icons/icons.component';


import { IconSvgDirective } from './icons/icon-svg.directive';
import { FooterComponent } from './footer/footer.component';



@NgModule({
  declarations: [
    AppComponent,
    AppHeaderComponent,
    AppBodyComponent,
    IconsComponent,
    SafePipe,
    IconSvgDirective,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    NgbModule.forRoot(),
    FormsModule,
    HttpClientModule,
    HttpModule,
    InlineSVGModule,
    AngularSvgIconModule
  ],

  providers: [DataService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/ubuntu/demo.airtory.com-stage/src/app/app.module.ts